// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2IJUF","imageUploader":"EGiftCard_imageUploader__35iP6"};